import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import CALENDAR_VIEW_TYPES from 'ui-addon-calendars/constants/CalendarViewTypes';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
export default function AllDayEventsCount({
  onToggleAllDayEvents,
  totalEvents,
  view
}) {
  return /*#__PURE__*/_jsx(Flex, {
    "data-test-id": "all-day-events-count",
    flex: "1 1 auto",
    alignItems: "center",
    padding: "200",
    position: "relative",
    justifyContent: view === CALENDAR_VIEW_TYPES.WEEK ? 'center' : 'start',
    paddingInlineStart: view === CALENDAR_VIEW_TYPES.DAY ? '200' : '0',
    children: /*#__PURE__*/_jsx(Button, {
      onClick: onToggleAllDayEvents,
      use: "link",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "calendar.event.allDayEventsCounter",
        options: {
          count: totalEvents
        }
      })
    })
  });
}